import {
  STATEMENT_STATUS,
  StatementStatus,
} from "@/billing/components/StatementsTab/constants/statements";

import { OpenStatementsColumn, OpenStatementsSearchOption } from "../types/open-statements";

export const TABLE_HEADER_HEIGHT = 72;

export const EMPTY_MESSAGE = "No open statements for this practice.";

export const LOAD_ERROR_MESSAGE = "Unable to load Open Statements. Please try again.";

export const REFRESH_OPEN_STATEMENTS_TABLE_LABEL = "Refresh open statements table";

export const OPEN_STATEMENTS_PAGE_SIZE = 20;
export const FILTERED_EMPTY_MESSAGE = "No open statements match the selected filters.";

export const STATUS_FILTER_ALL_LABEL = "All";

export const STATUS_FILTER_LABEL = "Status";

export const STATUS_FILTER_CHEVRON_SIZE = 14;

export const STATUS_FILTER_MENU_WIDTH = 320;

export const STATUS_FILTER_OPTION_HEIGHT = 56;

export const STATUS_FILTER_CHECK_SIZE = 20;

/**
 * The statuses the dashboard filter offers, in display order.
 *
 * Deliberately its own list rather than an alias of `INSURANCE_STATEMENT_STATUS_OPTIONS`: that
 * constant is the badge's *status-change* menu, and the two answer different questions. Filtering
 * by `Denied` is useful — it is a badge a row can actually show — but offering it as a manual
 * status change is not the badge's model, where `Denied` is reached through the `Accepted` branch.
 *
 * `In Processing` and `Denied` sit next to `Accepted` because they are that rollup's sub-statuses:
 * either one answers to both filters, which is why `Accepted` reads as the wider view of the same
 * branch. Unlike `Accepted`, both are badges `getStatementStatus` returns, so they match literally.
 */
export const STATUS_FILTER_OPTIONS: StatementStatus[] = [
  STATEMENT_STATUS.Unsent,
  STATEMENT_STATUS.Sent,
  STATEMENT_STATUS.Accepted,
  STATEMENT_STATUS.Processing,
  STATEMENT_STATUS.Denied,
  STATEMENT_STATUS.Rejected,
];

export const SEARCH_BAR_WIDTH = 480;

export const SEARCH_LABEL = "Search By";

export const SEARCH_OPTIONS = [
  { label: "Client", value: OpenStatementsSearchOption.Client },
  { label: "Payer", value: OpenStatementsSearchOption.Payer },
];

export const CLEAR_SEARCH_LABEL = "Clear search";

/** Shown in place of the rows when the practice has statements but none match the search. */
export const NO_SEARCH_RESULTS_MESSAGE = "No open statements match your search.";

export const SEARCH_PLACEHOLDERS = {
  [OpenStatementsSearchOption.Client]: "Search by Client Name",
  [OpenStatementsSearchOption.Payer]: "Search by Payer Name",
};

export const OPEN_STATEMENTS_COLUMNS: OpenStatementsColumn[] = [
  { key: "client-name", label: "Client Name", width: "14%", sort: "client-name" },
  { key: "service-date", label: "Service Date", width: "13%", sort: "service-date" },
  { key: "charges", label: "Charges", width: "11%", sort: "charges" },
  { key: "due-from", label: "Due From", width: "12%", sort: "due-from" },
  { key: "status", label: "Status", width: "17%", sort: "status" },
  { key: "payments", label: "Payments", width: "11%", sort: "payments" },
  { key: "adjustments", label: "Adjustments", width: "11%", sort: "adjustments" },
  { key: "balance", label: "Balance", width: "11%", sort: "balance" },
];

export const OPEN_STATEMENTS_COLUMN_SPAN = OPEN_STATEMENTS_COLUMNS.length;
